import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("select", {
      class: "form-select",
      value: _ctx.selectedValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitChange($event)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (label, value) => {
        return (_openBlock(), _createElementBlock("option", {
          key: value,
          value: value
        }, _toDisplayString(label), 9, _hoisted_2))
      }), 128))
    ], 40, _hoisted_1)
  ]))
}